module.exports = __webpack_public_path__ + "static/img/12.c7dd4291.png";